import React from 'react';

const PageContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  children,
  ...rest
}) => {
  return (
    <div className={['mx-auto w-full max-w-6xl px-4 py-8 sm:px-6 lg:px-8', className].join(' ')} {...rest}>
      {children}
    </div>
  );
};

export default PageContainer;
